import { render, staticRenderFns } from "./BookPcJiapu.vue?vue&type=template&id=12bbfb74&scoped=true&"
import script from "./BookPcJiapu.vue?vue&type=script&lang=js&"
export * from "./BookPcJiapu.vue?vue&type=script&lang=js&"
import style0 from "./BookPcJiapu.vue?vue&type=style&index=0&id=12bbfb74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbfb74",
  null
  
)

export default component.exports